module.exports = __webpack_public_path__ + "static/media/search_by_email.8a24c78a.png";